/***
 * Created on 2024/9/4
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../common/modal_dialog";
import {useTranslation} from "react-i18next";

function ChinaRegionLangWarningDialog({showModal, closeModal, submitAction}) {
    const { t } = useTranslation();

    return (
        <ModalDialog title={t('@Switch Region@')} showModal={showModal} closeModal={closeModal} submitText={t('@Switch@')} submitAction={submitAction} >
            <div className="dialog-content">
                <p>
                    {t('@China region only supports Simplified Chinese. If you would like to browse with other languages, you must switch to Global region. Do you want to switch to the global region?@')}
                </p>
                <p className="text-warning">{t("@Note: Using global region in China may slow down your browsing experience.@")}</p>
            </div>
        </ModalDialog>
    );
}

export default ChinaRegionLangWarningDialog;